import { Injectable, signal } from "@angular/core";

const LG_MIN_WIDTH_QUERY = "(min-width: 1024px)";

function initialOpen(): boolean {
  return typeof window !== "undefined" && window.matchMedia(LG_MIN_WIDTH_QUERY).matches;
}

@Injectable()
export class FormPreviewSplitStateService {
  readonly open = signal(initialOpen());

  toggle(): void {
    this.open.update((value) => !value);
  }
}
